import ForgotPasswordApp from './app/app';
import ReactDOM from 'react-dom';
import React from 'react';
import store from './data/store';
import { Provider } from 'react-redux';

/**
 * entry point
 */
const init = () => {
    const $root = document.getElementById('membership-forgot-password-app');
    if (!$root) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <ForgotPasswordApp />
            </Provider>
        </React.StrictMode>,
        $root
    );
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});

export {};